module.exports = __webpack_public_path__ + "img/D3F3.0b6a9b07.jpg";